import { BaseModel } from './BaseModel';
import Meeting from './Meeting';

export class MeetingAccount extends BaseModel {
  static get entity() {
    return 'meetings_account';
  }

  static get fk() {
    return 'meeting_account_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      email: this.attr(null),
      token: this.attr(null),
      request_content: this.attr(null),
      meetings: this.hasMany(Meeting, 'meeting_account_id'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }
}

export default MeetingAccount;
